import { render, staticRenderFns } from "./taak.vue?vue&type=template&id=3a7010ea&"
import script from "./taak.vue?vue&type=script&lang=ts&"
export * from "./taak.vue?vue&type=script&lang=ts&"
import style0 from "./taak.vue?vue&type=style&index=0&id=3a7010ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports